/** UP오더 언어 */
export enum LocaleLanguage {
  Ko = 'ko',
  En = 'en',
  Ja = 'ja',
  Zh = 'zh',
  Vi = 'vi',
}
